import { findDietTagImg } from '../helpers/singleOfferHelpers';
import classNames from 'classnames';
import IconDiv from './IconDiv';
import faCheck from '../img/icons/check.svg';

const ChooseDietModal = ({
  companyDietDetails,
  path,
  selectedDietId,
  selectDiet,
}) => {
  return (
    <>
      {companyDietDetails?.map(diet => {
        return (
          <div
            className="menu-widget-catering-menu__carousel-diets-mobile-modal-item"
            key={diet.dietIdWithTierId}
            onClick={() => selectDiet(diet)}
            onKeyPress={() => selectDiet(diet)}
            role="button"
            tabIndex="0"
          >
            <div
              className={
                'menu-widget-catering-menu__carousel-diets-mobile-modal-item-img'
              }
              style={{
                backgroundImage: `url(${diet?.dietImageUrl ? diet?.dietImageUrl : findDietTagImg(diet?.dietTag, path)})`,
              }}
            />
            <div
              className={classNames(
                'menu-widget-catering-menu__carousel-diets-mobile-modal-item-element',
                {
                  'menu-widget-catering-menu__carousel-diets-mobile-modal-item-element--color-primary':
                    diet.dietIdWithTierId === selectedDietId,
                }
              )}
            >
              {diet?.dietName}
              {diet.dietIdWithTierId === selectedDietId && (
                <IconDiv
                  classes="menu-widget-catering-menu-choose-modal-icon"
                  url={faCheck}
                  path={path}
                />
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ChooseDietModal;
